import HubSpotForm from '@components/hubspot/HubSpotForm';
import { ContentBlock } from '@layouts/ContentBlocks';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import useBreakpoints from '@ui/hooks/useBreakpoints';
import { makeSeoData } from 'config/next-seo.config';
import Head from 'next/head';
import Image from 'next/image';
import { NextSeo } from 'next-seo';
import React from 'react';

import useStyles from './referrals.style';

const title = 'Get $200 when you refer an agent!';
const description = 'Know a rockstar real estate agent? Earn $200 when you introduce a new customer to Guest House and they book their first staging.';

export default function Referrals() {
  const { classes, theme } = useStyles();
  const { md } = useBreakpoints();
  
  return (
    <>    
      <Head>
        <title>
          {title}
        </title>
      </Head>

      <NextSeo {...makeSeoData({ pageTitle: title, metaTitle:title, metaDescription: description })} />

      <ContentBlock
        maxWidth={1365}
      >
        <Grid
          container
          justifyContent="space-between"
          spacing={10}
        >
          <Grid
            item
            xs={12}
            md={6}
            style={{
              paddingTop: md ? 80 : 0
            }}
          >
            <Typography
              variant="h1"
              className={classes.heading}
            >
              {title}
            </Typography>

            <Typography
              className={classes.text}
              style={{ marginBottom: 16 }}
            >
              Know a rockstar real estate agent?
            </Typography>
            <Typography
              className={classes.text}
              style={{ marginBottom: 40 }}
            >
              Earn $200 when you introduce a new customer to Guest House and they book their first staging.
            </Typography>

            <HubSpotForm
              portalId= "8563089"
              formId= "d71f5063-0db0-4b3a-8e90-0e0b9dd0ed3f"
            />
            <Typography variant="caption">
              *Referral bonus is a one-time payment after customer books their first staging with Guest House. Bonus does not apply to agents who are existing Guest House customers. To qualify, all referrals must be submitted here. Referral submissions made after the agent books with Guest House do not qualify for payment.
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            className={classes.rightColumn}
          >
            <div
              style={{
                borderRadius: theme.shape.borderRadius,
                overflow: 'hidden',
                position: 'relative',
                height: md ? 660 : 600,
                width: md ? 520 : '100%',
              }}
            >
              <Image
                fill
                alt=""
                src="/images/home-buyer.png"
                className={classes.image}
                sizes="100vw"
              />
            </div>
          </Grid>
        </Grid>
      </ContentBlock>
    </>
  );
}
